import React from 'react';
import PropTypes from 'prop-types';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';

const BudgetNotEditableInternal = ({ i18n }) => (
  <div className="budget-info">
    <span className="budget-not-editable">{i18n.getString(_TL_('To change an experiment’s budget, you’ll need to change the budget of its original campaign.'))}</span>
  </div>
);

BudgetNotEditableInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

export const BudgetNotEditable = withI18nConsumer(BudgetNotEditableInternal);
